<template>
  <v-content>
    <v-layout
      v-if="nodata === true"
      align-center
      justify-center
      row
      wrap
      class="mt-5">
      <v-flex xs12>
        <v-avatar
          tile
          size="200"
          class="wevent_icon_wrapper_icons"> 
          <v-img
            class="wevent_icon_big"
            contain
            :src="require('@/assets/LOGO_SVG_v2.svg')"></v-img>
        </v-avatar>
      </v-flex>      
      <v-flex
        xs12
        class="headline white--text">
        No Data Available
      </v-flex>
    </v-layout>
    <v-layout
      v-if="loadposts"
      align-center
      justify-center
      row
      fill-height>
      <div class="loader">
        <div class="inner one" />
        <div class="inner two" />
        <div class="inner three" />
      </div>
    </v-layout>
    <template
      v-else>
      <v-card
        v-for="(post, i) in orderedPosts"
      
        :key="i"
        class="roundedcard mx-auto my-4 elevation-10"
      
        color="rgba(255, 255, 255, 0.3)"
        dark
        max-width="500">
        <v-toolbar
          flat
          color="transparent">
          <v-avatar
            tile
            size="32"> 
            <v-img
              contain
              :src="require('@/assets/Wevent_App_Icon.png')"></v-img>
          </v-avatar>
          <!-- <v-toolbar-title
            class="subheading font-weight-bold">
            {{ post.data.title.rendered }}
          </v-toolbar-title> -->
          <v-spacer></v-spacer>

          <span class="mr-1">
            {{ post.data.date | dateShort }}
          </span>
          <!-- <v-icon>fab fa-wordpress-simple</v-icon> -->
        </v-toolbar>
        <!-- 
      <v-card-text class="headline font-weight-bold">
        {{ post.data.title.rendered }}
      </v-card-text>
      -->
        <v-card-text
          class="mt-0 pt-0 title font-weight-bold text-xs-center">
          {{ post.data.title.rendered }}
        </v-card-text>
        <v-card-text 
          class="pt-0 pb-1"
          v-html="cleanUpHtml(post.data.content.rendered)">
        </v-card-text>

        <v-card-actions>
          <v-list-tile class="grow">
            <v-avatar
              tile
              size="32"
              class="wevent_icon_wrapper_icons"> 
              <v-img
                class="wevent_icon"
                contain
                :src="require('@/assets/LOGO_SVG_v2.svg')"></v-img>
            </v-avatar>
            <v-list-tile-content>
              <v-list-tile-title>WeVent</v-list-tile-title>
            </v-list-tile-content>

            <v-layout
          
              align-center
              justify-end>
              <v-btn
                fab
                
                flat
                :href="post.data.link + '/#comments'">
                <v-icon large>
                  fas fa-comments
                </v-icon>
              </v-btn>
            
              <template
                v-if="post.numComments > 0">
                <span class="ml-1">
                  ·
                </span>
                <span class="subheading ml-2">
                  {{ post.numComments }}
                </span>
              </template>
            
            <!-- <span class="subheading mr-2">
              {{ post._links.replies.length }}
            </span> -->
            <!-- <span class="mr-2">
              ·
            </span>
            <v-btn
              :href="post.data.link"
              fab
              small
              color="rgba(255,255,255,0.8)"
              class="grey--text">
              <v-icon>
                fas fa-external-link
              </v-icon>
            </v-btn> -->
            </v-layout>
          <!-- <v-layout v-else>
            <v-btn
              :href="post.data.link"
              fab
              small
              color="rgba(255,255,255,0.8)"
              class="grey--text">
              <v-icon>
                fas fa-external-link
              </v-icon>
            </v-btn> 
          </v-layout> -->
          </v-list-tile>
        </v-card-actions>
      </v-card>

      <v-card
        v-if="nodata === false"
        class="roundedcard mx-auto mb-5 mt-4 elevation-10"
        color="rgba(255, 255, 255, 0.1)"
        dark
        max-width="500">
        <v-card-text>
          <v-btn
            
            round
            dark
            color="rgba(255,255,255,0.3)"
            large
            href="https://www.wevent-news.de/">
            <v-icon
              left
              large>
              fas fa-newspaper
            </v-icon>
            <!-- TODO: Text/Translate -->

            Read all news ...
          </v-btn>
        </v-card-text>
      </v-card>
      <!-- fake-card for mobile -->
      <v-card
        v-if="nodata === false"
        class="mx-auto mt-1 elevation-10"
        style="height: 10px; visibility: hidden;"
        color="transparent"
        dark
        max-width="500">
      </v-card>
    </template>
  </v-content>
</template>
 
<script>
import axios from 'axios'
import { orderBy } from 'lodash'
// import sanitizeHtml from 'sanitize-html'

export default {
  data() {
    return {
      nodata: false,
      loadposts: false,
     
      posts: []
    }
  },
  computed: {
    orderedPosts() {
      return orderBy(this.posts, 'data.date', 'desc')
    },
  },
  created() {
    // axios.get('https://www.wevent-news.de/wp-json/wp/v2/comments')
    //   .then(res => console.log('1', res))
    //   .catch(error => console.log('1', error))

    this.getWPdata()
    
  },

  methods: {
    getWPdata() {
      this.loadposts = true
      this.nodata = false

      let numPosts
      axios.get('https://www.wevent-news.de/wp-json/wp/v2/posts')
    
        .then(res => {
        // for (let post in res.data) {
        //   this.posts.push(res.data[post])
        // }
          
          if (res.data.length < 5) {
            numPosts = res.data.length
          } else {
            numPosts = 5
          }
        
          for (let post = 0; post < numPosts; post++) {
            let postId = res.data[post].id
            let numComments
            
            axios.get('https://www.wevent-news.de/wp-json/wp/v2/comments?post=' + postId)
              .then(resCom => {
                numComments = resCom.data.length
                console.log(postId, resCom)
              })
              .then(() => {
                this.posts.push({ data: res.data[post], numComments: numComments })
              })
              .catch(errorCom => console.log(postId, errorCom))
            if (post === numPosts - 1) {
              setTimeout(() => {
                this.loadposts = false
              }, 800)

            }
          }
          console.log(res)
        })
        .then(() => {
          console.log('posts', this.posts)
          // this.loadposts = false

        })
        .catch(error => {
          console.log('2', error)
          this.loadposts = false
          this.nodata = true
        })
    },

    cleanUpHtml(val) {
      // let cleanHtml = sanitizeHtml(val, {
      //   allowedTags: sanitizeHtml.defaults.allowedTags.concat([
      //     'img',
      //     'figure'
      //   ]),
        
      // })
      // return cleanHtml
      return val
    }
  },
}
</script>
 
 <style scoped>

 div >>> img {
   border-radius: 16px;
 }

 .wevent_icon {
  height: 40px !important;
  -webkit-filter: invert(1) opacity(1);
  filter: invert(1) opacity(1);

  /* filter: invert(0.6) sepia(0.8) saturate(5) hue-rotate(330deg); */
}
 .wevent_icon_big {
  height: 300px !important;
  -webkit-filter: invert(1) opacity(1);
  filter: invert(1) opacity(1);

  /* filter: invert(0.6) sepia(0.8) saturate(5) hue-rotate(330deg); */
}






.loader {
  position: absolute;
  top: calc(50% - 70px);
  left: calc(50% - 70px);
  width: 140px;
  height: 140px;
  border-radius: 50%;
  perspective: 800px;
}

.inner {
  position: absolute;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  border-radius: 50%;  
}

.inner.one {
  left: 0%;
  top: 0%;
  animation: rotate-one 1s linear infinite;
  border-bottom: 5px solid #EFEFFA;
}

.inner.two {
  right: 0%;
  top: 0%;
  animation: rotate-two 1s linear infinite;
  border-right: 5px solid #EFEFFA;
}

.inner.three {
  right: 0%;
  bottom: 0%;
  animation: rotate-three 1s linear infinite;
  border-top: 5px solid #EFEFFA;
}

@keyframes rotate-one {
  0% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);
  }
}

@keyframes rotate-two {
  0% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);
  }
}

@keyframes rotate-three {
  0% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);
  }
}
 </style>
 